import { data } from 'autoprefixer';
import React from 'react'
import ReactApexChart from 'react-apexcharts';


export default function ApexChart({title,name ,data,categories,type}) {
    const series = [
    {
      name: name,
      data: data,
    },
  ];

  const options = {
    chart: {
      type: type,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    dataLabels: { enabled: false },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.1,
      },
    },
    xaxis: {
      categories: categories,
    },
   // ✅ Prefix ₹ on Y-axis
    yaxis: {
      labels: {
        formatter: (value) => `₹${value}`,
      },
    },
     // ✅ Prefix ₹ in tooltip popup
    tooltip: {
      y: {
        formatter: (val) => `₹${val}`,
      },
    },
    grid: {
      borderColor: "#e5e7eb", // Tailwind slate-200
      
    },
  };
  return (
  <div className="bg-white dark:bg-slate-900 p-4 rounded-2xl shadow-md w-full">
      <h2 className="text-md font-semibold mb-2 text-slate-700 dark:text-slate-200">
        {title}
      </h2>

      <ReactApexChart
        options={options}
        series={series}
        type={type}
        height={300}
      />
      </div>
  )
}
